import axios from 'axios';
import apiConfig from '../api.config';

export default function upsellSendEmailToGuestRejectedRequest({ hotelSlug, pmsId, tags }) {
  const {
    upsellHost,
    URIs: { upsellSendEmailToGuestRejected },
  } = apiConfig;

  // workaround: Guestlink does not support htts rigth now on PROD
  const uri = `${upsellHost}${upsellSendEmailToGuestRejected}`;

  return axios
    .post(
      uri,
      JSON.stringify({ hotelSlug, pmsId, schedule: 'guest-rejected', options: { tags } }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
}
